import { createContext, useCallback, useEffect, useState } from 'react'
import { useVestigioService } from 'hooks/useVestigioService'
export const CestaContext = createContext({})

export const CestaProvider = ({ children }) => {
  const vestigioService = useVestigioService()
  const [vestigiosSelecionados, setVestigiosSelecionados] = useState([])
  const [reloadListeners, setReloadListeners] = useState(false)
  const [vestigiosComCadeiaCustodia, setVestigiosComCadeiaCustodia] = useState([])
  const [reloadSelecionados, setReloadSelecionados] = useState(false)
  const [processandoVestigiosComCadeiaCustodia, setProcessandoVestigiosComCadeiaCustodia] = useState(false)

  const fetchVestgiosComCadeiaCustodia = useCallback(async () => {
    setProcessandoVestigiosComCadeiaCustodia(true)
    if (vestigiosSelecionados.length) {
      const result = await vestigioService.listarVestigiosComCadeiaCustodia(vestigiosSelecionados.map((v) => v.id))
      setVestigiosComCadeiaCustodia(result)
    } else {
      setVestigiosComCadeiaCustodia([])
    }
    setProcessandoVestigiosComCadeiaCustodia(false)
    if (reloadSelecionados) {
      setReloadSelecionados(false)
    }
  }, [vestigiosSelecionados, reloadSelecionados])

  useEffect(() => {
    fetchVestgiosComCadeiaCustodia()
  }, [fetchVestgiosComCadeiaCustodia])

  const addVestigio = (novoVestigio) => {
    setVestigiosSelecionados((prevState) => [...prevState, novoVestigio])
  }

  const removerVestigio = (id) => {
    let index = -1
    let novaListaVestigios = [...vestigiosSelecionados]
    novaListaVestigios.forEach((v, i) => {
      if (v.id === id) {
        index = i
      }
    })
    novaListaVestigios.splice(index, 1)
    setVestigiosSelecionados([...novaListaVestigios])
  }

  const removerListaVestigios = (ids) => {
    let novaListaVestigios = [...vestigiosSelecionados]
    novaListaVestigios = novaListaVestigios.filter((v) => !ids.includes(v.id))
    setVestigiosSelecionados([...novaListaVestigios])
  }

  const verificarItemEmCesta = (id) => {
    return vestigiosSelecionados.some((vestigio) => vestigio.id === id)
  }

  return (
    <CestaContext.Provider
      value={{
        vestigiosSelecionados,
        vestigiosComCadeiaCustodia,
        processandoVestigiosComCadeiaCustodia,
        setVestigiosSelecionados,
        addVestigio,
        removerVestigio,
        removerListaVestigios,
        verificarItemEmCesta,
        reloadSelecionados,
        setReloadSelecionados,
        reloadListeners,
        setReloadListeners,
      }}
    >
      {children}
    </CestaContext.Provider>
  )
}
